module.exports = __webpack_public_path__ + "img/Kraftfahrzeug_Geländegängig.41011377.svg";